module.exports = __webpack_public_path__ + "img/h-sc.e8e1d9e5.png";